<template>
  <fragment>
    <v-row>
      <slot name="prefix" />

      <secretary-info
        v-if="legalCapacityId==legalCapacitiesEnum.bankruptcySecretary && !isGovType"
        :form-model="formModel"
        :audit-confirmations="auditConfirmations"
        :is-view-mode="isViewMode"
        :is-new-mode="isNewMode"
        :is-edit-mode="isEditMode"
        :is-not-completed="isNotCompleted"
      ></secretary-info>

      <representative-info
        v-if="legalCapacityId==legalCapacitiesEnum.legalEntityRepresentative"
        :form-model="formModel"
        :audit-confirmations="auditConfirmations"
        :is-view-mode="isViewMode"
        :is-new-mode="isNewMode"
        :is-edit-mode="isEditMode"
        :is-not-completed="isNotCompleted"
      ></representative-info>

      <v-col
        cols="12"
        lg="3"
      >
        <naj-input
          v-mask="'05########'"
          :type-id="formFieldType.text"
          :label="local.bankruptcy.requestApplicant.mobileNumber"
          :value.sync="formModel.mobile"
          :validates="`required|digits:10`"
          :disabled="isViewMode || (auditConfirmations[`flag_${mainRequestAuditFlag.applicantDetailsConfirmation}`] && isNotCompleted)"
        ></naj-input>
      </v-col>
      <v-col
        cols="12"
        lg="3"
      >
        <naj-input
          :type-id="formFieldType.text"
          :label="local.bankruptcy.requestApplicant.email"
          :value.sync="formModel.email"
          :validates="`required|email|no_gov_email`"
          :disabled="isViewMode || (auditConfirmations[`flag_${mainRequestAuditFlag.applicantDetailsConfirmation}`] && isNotCompleted)"
        ></naj-input>
      </v-col>
    </v-row>
    <applicant-info :info="formModel"></applicant-info>
    <v-col cols="12">
      <audit-confirmation-flag-checkbox :audit-flag="mainRequestAuditFlag.applicantDetailsConfirmation"></audit-confirmation-flag-checkbox>
    </v-col>
  </fragment>
</template>

<script>
import ApplicantInfo from './applicant-info.vue';
import SecretaryInfo from './secretary-info.vue';
import RepresentativeInfo from './representative-info.vue';
import { legalCapacitiesEnum, mainRequestAuditFlag, requestStatusEnum } from '@/modules/bankruptcy/helpers/enum';
import AuditConfirmationFlagCheckbox from '@/modules/bankruptcy/components/request/audit-confirmation-flag-checkbox';
export default {
  name: 'RequestApplicant',
  inject: ['$validator'],
  components: {
    ApplicantInfo,
    SecretaryInfo,
    RepresentativeInfo,
    AuditConfirmationFlagCheckbox,

  },
  props: {
    formModel: {
      type: Object,
      required: true,
    },
    auditConfirmations: {
      type: Object,
      required: true,
    },
    isNewMode: {
      type: Boolean,
      required: true,
    },
    isViewMode: {
      type: Boolean,
      required: true,
    },
    isEditMode: {
      type: Boolean,
      required: true,
    },
    isNotCompleted: {
      type: Boolean,
      required: true,
    },
    legalCapacityId: {
      type: Number,
      required: false,
      default: null,
    },
    isGovType: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      legalCapacitiesEnum,
      mainRequestAuditFlag,
      requestStatusEnum,
    };
  },
  computed: {},
  watch: {
    legalCapacityId(newValue) {
      if (newValue == legalCapacitiesEnum.legalEntityRepresentative) {
        this.$set(this.formModel, 'secretaryLicenceNumber', undefined);
      } else if (newValue == legalCapacitiesEnum.bankruptcySecretary) {
        this.$set(this.formModel, 'mojLicenceNumber', undefined);
      } else {
        this.$set(this.formModel, 'mojLicenceNumber', undefined);
        this.$set(this.formModel, 'secretaryLicenceNumber', undefined);
      }
    },
  },
  methods: {},
};
</script>

<style lang="scss">
</style>
